import { EVENTS } from '../constants/webSocketConsts/events';
import {
  insertFilesNotifications,
  updateNotifications,
  deleteNotifications,
} from '../store/notifications/actions';
import { NotificationGroups } from '../store/notifications/types';

export const FileNotificationsHandler = (
  notificationType: NotificationGroups,
  event: string,
  items: Array<any>,
  allowMarkingNotificationAsRead?: boolean,
) => {
  switch (event) {
    case EVENTS.INSERT:
      return insertFilesNotifications(
        items,
        notificationType,
        allowMarkingNotificationAsRead,
      );
    case EVENTS.MODIFY:
      return updateNotifications(items, notificationType);
    case EVENTS.REMOVE:
      return deleteNotifications(items, notificationType);
    default:
      break;
  }
  return null;
};
